import { useParams, useNavigate } from 'react-router-dom';
import BusinessDetailPanel from '../components/BusinessDetailPanel.jsx';
import useCampaign from '../hooks/useCampaign.js';

export default function BusinessDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { campaignId } = useCampaign();

  return (
    <div className="h-full flex items-start justify-center bg-gray-50 p-6">
      <BusinessDetailPanel
        businessId={id}
        campaignId={campaignId}
        onClose={() => navigate(-1)}
      />
    </div>
  );
}
